import {loginConfirmedAction, logout} from '../store/actions/AuthActions';
import axiosInstance from "./AxiosInstance";
import indexedDBService from './IndexedDBService';

export function signUp(userParams) {
    return axiosInstance.post(`/api/auth`, userParams);
}

export function telegramLogin(id) {
    return axiosInstance.post(`/api/telegram/login`, {telegram_id: id}, {removeHeaders: true});
}

export function appleLogin(id) {
    return axiosInstance.post(`/api/apple/login`, {id_token: id}, {removeHeaders: true});
}

export function googleLogin(idToken) {
    return axiosInstance.post(`/api/google/login`, {id_token: idToken}, {removeHeaders: true});
}

export function login(email, password) {
    const postData = {email, password};
    return axiosInstance.post(`/api/auth/sign_in`, postData);
}

export function submitForgotPassword(email) {
    const postData = { email, redirect_url: `${window.location.protocol}//${window.location.host}/password` };
    return axiosInstance.post(`/api/auth/password`, postData);
}

export function updateForgotPassword(params) {
    return axiosInstance.put(`/api/auth/password`, params);
}

export function getProfile() {
    return axiosInstance.get(`/api/profile`);
}

export function submitProfile(profile) {
    if (profile.pictureForUpload) {
        var formData = new FormData();
        formData.append("profile[picture]", profile.pictureForUpload);
        formData['headers'] = {'Content-Type': 'multipart/form-data' };
    } else {
        delete profile["picture"]
    }
    return axiosInstance.put(`/api/profile`, profile.pictureForUpload ? formData : {profile: profile});
}

export function destroyPhotoProfile() {
    return axiosInstance.delete(`/api/profile`);
}

export function destroyProfile() {
    return axiosInstance.delete(`/api/profile/destroy_profile`);
}

export function submitTelegram(telegram) {
    return axiosInstance.put(`/api/telegram/update_user`, {telegram: telegram});
}

export function submitApple(idToken) {
    return axiosInstance.put(`/api/apple/update_user`, {id_token: idToken});
}

export function submitGoogle(idToken) {
    return axiosInstance.put(`/api/google/update_user`, {id_token: idToken});
}

export function submitShift(shift) {
    return indexedDBService.getUserData('userDetails').then(tokenDetails => {
    const params = { restaurant_id: tokenDetails.restaurant ? tokenDetails.restaurant.id : '', working: shift};
    return axiosInstance.put(`/api/management/settings/restaurant_stuffs/shift`, params);
    });
}

export function authorizeAccess() {
    return axiosInstance.get(`/api/authorize_access`);
}

export function sendPushToken(token, device) {
    const params = {user_device: {token: token, device_type: device}};
    return axiosInstance.post(`/api/user_devices`, params);
}

export function saveTokenInLocalStorage(response) {
    const headers = response.headers || response;
    const access_token = headers['access-token'] || response['access-token'];
    const client = headers['client'] || response['client'];
    const uid = headers['uid'] || response['uid'];
    const expiry = headers['expiry'] || response['expiry'];
    const responseUser = response.data?.user || response.user;

    return indexedDBService.getUserData('userDetails').then(oldDetails => {
        const userDetails = {
            ...oldDetails,
            idToken: access_token || oldDetails?.idToken,
            client: client || oldDetails?.client,
            uid: uid || oldDetails?.uid,
            expireDate: expiry ? parseInt(expiry) * 1000 : oldDetails?.expireDate,
            userData: responseUser ? { ...oldDetails?.userData, ...responseUser } : (oldDetails?.userData || {}),
            restaurant: response.data?.restaurant || (!!response.data?.restaurants && response.data.restaurants[0]) || oldDetails?.restaurant,
            restaurants: response.data?.restaurants || oldDetails?.restaurants,
        };
        return indexedDBService.setUserData('userDetails', userDetails).then(() => userDetails);
    });
}

export function saveProfileInLocalStorage(profile, restaurants) {
    return indexedDBService.getUserData('userDetails').then(userDetails => {
    userDetails.userData = profile;
    userDetails.uid = profile.email;
    if (!!restaurants) {
        userDetails.restaurant = restaurants[0];
        userDetails.restaurants = restaurants;
    }
        return indexedDBService.setUserData('userDetails', userDetails);
    });
}

export function saveActiveOrderInLocalStorage(order) {
    return indexedDBService.getOrderData('activeOrders').then(oldActiveOrders => {
        const mergedActiveOrders = Object.assign(oldActiveOrders || {}, {[order.id]: order});
        return indexedDBService.setOrderData('activeOrders', mergedActiveOrders);
    });
}

// export function shouldAskOrdersInRequest() {
//     return indexedDBService.getOrderData('activeOrders').then(orders => !!orders);
// }

export function runLogoutTimer(dispatch, timer, history) {
    setTimeout(() => {
        dispatch(logout(history));
    }, timer);
}

export function checkAutoLogin(dispatch, history) {
    return indexedDBService.getUserData('userDetails').then(tokenDetails => {
        if (!tokenDetails) {
        dispatch(logout(history));
        return;
    }

    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();
    if (todaysDate > expireDate) {
        dispatch(logout(history));
        return;
    }
    dispatch(loginConfirmedAction(tokenDetails));

    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, history);
    });
}

export function setStoreAuth(dispatch, history) {
    return indexedDBService.getUserData('userDetails').then(tokenDetails => {
    if (!!tokenDetails?.idToken) {
        const expireDate = new Date(tokenDetails.expireDate);
        const todaysDate = new Date();
        if (todaysDate > expireDate) {
            dispatch(logout(history));
            return;
        }
        dispatch(loginConfirmedAction(tokenDetails));

        const timer = expireDate.getTime() - todaysDate.getTime();
        runLogoutTimer(dispatch, timer, history);
    }
    });
}
